import React from 'react';
import {Link} from 'react-router-dom';

export default class FooterOne extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                {/* Start Footer One */}
                <footer className="footer-one">
                    <div className="footer-one__top">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="footer-one__top-inner">
                                        <div className="row">

                                            {/* Start Footer Widget Column */}
                                            <div className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                                <div className="footer-widget__column footer-widget__about">
                                                    <div className="footer-widget__about-logo">
                                                        <Link to={process.env.PUBLIC_URL + `/`} className="freshswfl-logo__lockup">
                                                            <img
                                                                className="freshswfl-logo__icon"
                                                                src={publicUrl + "favicon.svg"}
                                                                alt="Fresh SWFL"
                                                            />
                                                            <span className="freshswfl-logo__text">
                                                                Fresh SWFL
                                                                <span className="freshswfl-logo__tagline">Southwest Florida local food guide</span>
                                                            </span>
                                                        </Link>
                                                    </div>

                                                    <p className="footer-widget__about-text">
                                                        Fresh SWFL curates farms, markets, and farm-to-table dining so you can shop local with confidence.
                                                    </p>

                                                    <ul className="footer-widget__about-contact-info">
                                                        <li>
                                                            <div className="icon">
                                                                <span className="fa fa-leaf"></span>
                                                            </div>
                                                            <div className="text">
                                                                <p>Updated weekly with seasonal picks and market schedules.</p>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="icon">
                                                                <span className="fa fa-map-marker"></span>
                                                            </div>
                                                            <div className="text">
                                                                <p>Serving Fort Myers, Cape Coral, Naples, and nearby communities.</p>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="icon">
                                                                <span className="fa fa-envelope"></span>
                                                            </div>
                                                            <div className="text">
                                                                <p><a href="mailto:info@freshswfl.com">info@freshswfl.com</a></p>
                                                            </div>
                                                        </li>
                                                    </ul>

                                                    <div className="footer-widget__about-social-link">
                                                        <ul>
                                                            <li>
                                                                <a href="https://www.facebook.com/freshswfl" aria-label="Fresh SWFL on Facebook">
                                                                    <span className="first icon-facebook-app-symbol"></span>
                                                                    <span className="second icon-facebook-app-symbol"></span>
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href="https://www.instagram.com/freshswfl" aria-label="Fresh SWFL on Instagram">
                                                                    <span className="first icon-instagram"></span>
                                                                    <span className="second icon-instagram"></span>
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href="https://twitter.com/freshswfl" aria-label="Fresh SWFL on Twitter">
                                                                    <span className="first icon-twitter"></span>
                                                                    <span className="second icon-twitter"></span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* End Footer Widget Column */}

                                            {/* Start Footer Widget Column */}
                                            <div className="col-xl-2 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.3s">
                                                <div className="footer-widget__column footer-widget__services">
                                                    <h2 className="footer-widget__title">Explore</h2>
                                                    <ul className="footer-widget__services-list">
                                                        <li className="footer-widget__services-list-item"><Link to={process.env.PUBLIC_URL + `/browse`}>Browse Directory</Link></li>
                                                        <li className="footer-widget__services-list-item"><Link to={process.env.PUBLIC_URL + `/recipes`}>Recipes</Link></li>
                                                        <li className="footer-widget__services-list-item"><Link to={process.env.PUBLIC_URL + `/produce-directory`}>Produce Guide</Link></li>
                                                        <li className="footer-widget__services-list-item"><Link to={process.env.PUBLIC_URL + `/category/farmers-markets`}>Farmers Markets</Link></li>
                                                        <li className="footer-widget__services-list-item"><Link to={process.env.PUBLIC_URL + `/category/farms`}>Local Farms</Link></li>
                                                        <li className="footer-widget__services-list-item"><Link to={process.env.PUBLIC_URL + `/category/csa-programs`}>CSA Programs</Link></li>
                                                        <li className="footer-widget__services-list-item"><Link to={process.env.PUBLIC_URL + `/seasonal`}>Seasonal Produce</Link></li>
                                                        <li className="footer-widget__services-list-item"><Link to={process.env.PUBLIC_URL + `/seasonal-guides`}>Seasonal Guides</Link></li>
                                                        <li className="footer-widget__services-list-item"><Link to={process.env.PUBLIC_URL + `/events`}>Blog & Articles</Link></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            {/* End Footer Widget Column */}

                                            {/* Start Footer Widget Column */}
                                            <div className="col-xl-2 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.5s">
                                                <div className="footer-widget__column footer-widget__link">
                                                    <h2 className="footer-widget__title">Get Involved</h2>
                                                    <ul className="footer-widget__link-list">
                                                        <li className="footer-widget__link-list-item"><Link to={process.env.PUBLIC_URL + `/map`}>Map View</Link></li>
                                                        <li className="footer-widget__link-list-item"><Link to={process.env.PUBLIC_URL + `/favorites`}>Favorites</Link></li>
                                                        <li className="footer-widget__link-list-item"><Link to={process.env.PUBLIC_URL + `/compare`}>Compare Vendors</Link></li>
                                                        <li className="footer-widget__link-list-item"><Link to={process.env.PUBLIC_URL + `/about`}>About Fresh SWFL</Link></li>
                                                        <li className="footer-widget__link-list-item"><Link to={process.env.PUBLIC_URL + `/contact`}>Contact Us</Link></li>
                                                        <li className="footer-widget__link-list-item"><a href="/sitemap.xml" target="_blank" rel="noopener noreferrer">Sitemap</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            {/* End Footer Widget Column */}

                                            {/* Start Footer Widget Column */}
                                            <div className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.7s">
                                                <div className="footer-widget__column footer-widget__map">
                                                    <h2 className="footer-widget__title">SWFL Map</h2>
                                                    <div className="footer-widget__map-box">
                                                        <iframe
                                                            src="https://www.google.com/maps?q=Southwest%20Florida&output=embed"
                                                            className="footer-widget-map__one"
                                                            allowFullScreen
                                                            loading="lazy"
                                                            title="Southwest Florida map"
                                                        ></iframe>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* End Footer Widget Column */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Start Footer One Bottom */}
                    <div className="footer-one__bottom clearfix">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="footer-one__bottom-inner text-center">
                                        <div className="footer-one__bottom-text">
                                            <p>© {new Date().getFullYear()} <Link to={process.env.PUBLIC_URL + `/`}>Fresh SWFL</Link>. All rights reserved.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Footer One Bottom */}
                </footer>
                {/* End Footer One */}
            </>
        )
    }
}
